import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, createClient } from './App.tsx';
import './design/tokens.css';
import './design/layout.css';
import './design/cards.css';
import './design/table.css';
import './design/mobile.css';
import { I18nProvider } from './i18n/index.tsx';

const client = createClient();
client.connect();

// The game still requires a connection to play, but the installed shell and
// its first frame are available immediately on a returning player's device.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Offline polish must never prevent the table from opening. */
    });
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App client={client} />
    </I18nProvider>
  </StrictMode>,
);
